import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=6d2c48c1&scoped=true&"
import script from "./WorkFlow.vue?vue&type=script&lang=js&"
export * from "./WorkFlow.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=6d2c48c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c48c1",
  null
  
)

export default component.exports